var map = {
	"./15.svg": 7945,
	"./16.svg": 2922,
	"./18.svg": 124,
	"./19.svg": 9597,
	"./20.svg": 3373,
	"./21.svg": 9100,
	"./31.svg": 6579,
	"./32.svg": 5840,
	"./33.svg": 2753,
	"./34.svg": 926,
	"./35.svg": 8863,
	"./36.svg": 6188,
	"./39.svg": 1163,
	"./40.svg": 9331,
	"./41.svg": 6690,
	"./42.svg": 1233,
	"./43.svg": 8432,
	"./44.svg": 6991,
	"./47.svg": 5292,
	"./48.svg": 2939,
	"./50.svg": 1904,
	"./51.svg": 4145,
	"./52.svg": 9106,
	"./53.svg": 7043,
	"./55.svg": 3037,
	"./57.svg": 7791,
	"./default.svg": 314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9829;